/**
 * Resolves the `VITE_AUTH_ALLOWED_REDIRECT_HOSTS` environment variable into an array of
 * trusted host suffixes used by `isSafeRedirectUrl` to validate server-supplied redirect URLs.
 *
 * The value is a comma-separated list of host suffixes:
 * - Bare hostnames like `localhost` match exactly.
 * - Entries starting with `.` like `.ayeldo.com` match the apex and all subdomains.
 *
 * @param env - The Vite `import.meta.env` object (injectable for testing).
 * @returns An array of trimmed, non-empty host suffix strings.
 * @throws {Error} In production builds when the env var is not configured.
 */
export function resolveAuthAllowedRedirectHosts(env) {
    const raw = env.VITE_AUTH_ALLOWED_REDIRECT_HOSTS;
    const value = typeof raw === 'string' ? raw.trim() : '';
    if (value !== '') {
        return value
            .split(',')
            .map((s) => s.trim())
            .filter((s) => s.length > 0);
    }
    if (env.DEV) {
        // Default for local development; overrideable via .env
        return ['localhost', '.dev.ayeldo.com', '.ayeldo.com'];
    }
    throw new Error('VITE_AUTH_ALLOWED_REDIRECT_HOSTS is not configured for production build');
}
